module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp50"
  }, [_c('el-form', {
    ref: "changePwdForm",
    attrs: {
      "size": "mini",
      "model": _vm.changePwdForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "newPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changePwdForm.newPass),
      callback: function($$v) {
        _vm.$set(_vm.changePwdForm, "newPass", $$v)
      },
      expression: "changePwdForm.newPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.changePwdForm.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.changePwdForm, "checkPass", $$v)
      },
      expression: "changePwdForm.checkPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('changePwdForm')
      }
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('changePwdForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3783ceef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/passport/changePassword.vue
// module id = 901
// module chunks = 0